import { Box } from '@mui/material';
import { ResponsiveLine } from '@nivo/line';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { LegacyFAIcon, LegacyFAIcons } from '~/legacy-components/LegacyFAIcon';
import { LegacyHeadingWithActions } from '~/legacy-components/LegacyLayout';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';

import { usePerformanceComponent } from './usePerformanceComponent';
import { useSxStyles } from './useStyles';

export const PerformanceComponent = () => {
  const { t } = useTranslation();
  const sxStyles = useSxStyles();

  const {
    performanceData,
    chart: { chartWidth, chartData, maxVal, minVal },
    isLoading,
  } = usePerformanceComponent();

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <>
      <div>
        <Box component="table" sx={sxStyles.table}>
          <caption>
            <LegacyHeadingWithActions
              headingIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Table} />}
              heading={t('laPerformanceReviews')}
            />
          </caption>
          <thead>
            <tr>
              <Box component="th" sx={sxStyles.thDate}>
                {t('laDate')}
              </Box>
              <Box component="th" sx={sxStyles.thPerf}>
                {t('laTotalPerformance')}
              </Box>
              <Box component="th" sx={sxStyles.thComment}>
                {t('laTransactionComment')}
              </Box>
            </tr>
          </thead>
          <tbody>
            {performanceData.map((perf, index) => {
              return (
                <tr key={index}>
                  <Box component="td" sx={sxStyles.td}>
                    {moment(perf.fTransactionEnteredTime).format('DD.MM.YYYY')}
                  </Box>
                  <Box component="td" sx={sxStyles.td}>
                    {perf.fPerfTotalScore.toString().replace('.', ',')}
                  </Box>
                  <Box component="td" sx={sxStyles.td}>
                    {perf.fTransactionComment}
                  </Box>
                </tr>
              );
            })}
          </tbody>
        </Box>
      </div>
      <Box component="hr" sx={sxStyles.hr} />
      <div>
        <LegacyHeadingWithActions
          headingIcon={<LegacyFAIcon FAIcon={LegacyFAIcons.Table} />}
          heading={t('laPerformanceGraphic')}
        />
        {performanceData.length && (
          <Box sx={sxStyles.chart} style={{ width: `${chartWidth}px` }}>
            <ResponsiveLine
              data={[
                {
                  id: 'score',
                  data: chartData,
                },
              ]}
              margin={{ top: 30, right: 120, bottom: 70, left: 60 }}
              colors={'#00ace6'}
              xScale={{
                type: 'point',
              }}
              yScale={{
                type: 'linear',
                min: minVal,
                max: maxVal,
                stacked: false,
              }}
              axisTop={null}
              axisRight={null}
              axisLeft={{
                tickSize: 8,
                tickPadding: 6,
                tickRotation: 0,
                legend: t('laPerformance'),
                legendOffset: -55,
                legendPosition: 'middle',
                tickValues: 6,
              }}
              axisBottom={{
                tickSize: 0,
                tickRotation: 25,
                tickPadding: 10,
                legend: t('laEvaluations'),
                legendPosition: 'middle',
                legendOffset: 55,
              }}
              pointSize={8}
              pointColor={'#00ace6'}
              enablePointLabel={true}
              pointLabelYOffset={-8}
              pointBorderWidth={2}
              pointBorderColor={'#00ace6'}
              useMesh={true}
            />
          </Box>
        )}
      </div>
    </>
  );
};
